import { useEffect, useState } from "react"

/**
 * Carrega o Mapbox GL JS sob demanda a partir do CDN oficial (script + css),
 * apenas para clientes configurados com MapBox. Assim o Mapbox não entra no
 * bundle nem no package-lock, e clientes Google não baixam nada disso — mesma
 * estratégia de carregamento externo usada pelo Google Maps (LoadScript).
 */
const VERSAO_MAPBOX = "v3.7.0"
const URL_JS = `https://api.mapbox.com/mapbox-gl-js/${VERSAO_MAPBOX}/mapbox-gl.js`
const URL_CSS = `https://api.mapbox.com/mapbox-gl-js/${VERSAO_MAPBOX}/mapbox-gl.css`
const ID_JS = "mapbox-gl-js"
const ID_CSS = "mapbox-gl-css"

interface EstadoMapbox {
    loaded: boolean
    erro: string | null
}

export function useMapboxGl(): EstadoMapbox {
    const [estado, setEstado] = useState<EstadoMapbox>(() => ({
        loaded: !!(window as any).mapboxgl,
        erro: null,
    }))

    useEffect(() => {
        if ((window as any).mapboxgl) {
            setEstado({ loaded: true, erro: null })
            return
        }

        if (!document.getElementById(ID_CSS)) {
            const link = document.createElement("link")
            link.id = ID_CSS
            link.rel = "stylesheet"
            link.href = URL_CSS
            document.head.appendChild(link)
        }

        let script = document.getElementById(ID_JS) as HTMLScriptElement | null
        const aoCarregar = () => setEstado({ loaded: true, erro: null })
        const aoFalhar = () =>
            setEstado({ loaded: false, erro: "Não foi possível carregar o mapa (Mapbox)." })

        if (!script) {
            script = document.createElement("script")
            script.id = ID_JS
            script.src = URL_JS
            script.async = true
            script.addEventListener("load", aoCarregar)
            script.addEventListener("error", aoFalhar)
            document.body.appendChild(script)
        } else {
            script.addEventListener("load", aoCarregar)
            script.addEventListener("error", aoFalhar)
            if ((window as any).mapboxgl) aoCarregar()
        }

        return () => {
            if (script) {
                script.removeEventListener("load", aoCarregar)
                script.removeEventListener("error", aoFalhar)
            }
        }
    }, [])

    return estado
}
